import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { useFlags } from "launchdarkly-react-client-sdk";
import { isSilentObserverAvailable } from "../../shared/function";
import useLanguageChange from "../../hooks/useLanguageChange";
import {
    checkIsAudioPermissionBlock,
    handleToggleAudio,
    micButtonLDFlagStatus,
    requestMicPermissionToTheAgent,
} from "../Twilio/AudioCall/AudioCallUtils";
import { setIsAudioButtonClickDisable } from "../../reducers/common-reducer";
import { handleStartStopAudioPlaySound } from "../Twilio/Room/roomFunction";

const WhisperButton = () => {
    const dispatch = useDispatch();
    const { isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const localisedValues = useLanguageChange();
    const { startLocalAudio } = useSelector((state) => state.twilioEvents);
    const ldFlags = useFlags();

    const checkAudioEnable = useMemo(() => {
        return isRemoteParticipantJoined && startLocalAudio === true;
    }, [isRemoteParticipantJoined, startLocalAudio]);

    const toggleAudio = () => {
        handleStartStopAudioPlaySound(!startLocalAudio); // handle heptic feedback
        if (requestMicPermissionToTheAgent()) return;
        dispatch(setIsAudioButtonClickDisable(true)); // disable audio button(button click variable)
        if (checkIsAudioPermissionBlock()) return;
        handleToggleAudio();
    };

    return (
        <>
            {isSilentObserverAvailable() && (
                <div className='action-button' data-testid='WisperButtonComponent'>
                    <div className='action-button-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width'>
                        <button
                            className={clsx("call-action-btn", checkAudioEnable ? "active" : "")}
                            onClick={toggleAudio}
                            disabled={!isRemoteParticipantJoined || !micButtonLDFlagStatus(ldFlags?.micButtonStatus)}
                            data-testid='wisper-button'
                        >
                            <span className='action-button-icon'>
                                <span className={clsx("for-icon", startLocalAudio === true ? "icon-whisper-on" : "icon-whisper-off")}></span>
                            </span>
                            <span className='for-text'>{localisedValues?.whisper_label}</span>
                        </button>
                        {isRemoteParticipantJoined && (
                            <div className='custom-tooltip-content text-nowrap'>
                                <div className='custom-tooltip-in'>
                                    <p>
                                        {!micButtonLDFlagStatus(ldFlags?.micButtonStatus) &&
                                            !startLocalAudio &&
                                            localisedValues["audio_disabled_by_admin"]}
                                        {!startLocalAudio &&
                                            micButtonLDFlagStatus(ldFlags?.micButtonStatus) &&
                                            localisedValues["enable_whisper_tooltip_label"]}
                                        {startLocalAudio && localisedValues["host_can_hear_you_now"]}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default WhisperButton;
